import { cx } from 'cva';
import { type FunctionComponent } from 'react';
import ALLIANCE_OF_HEALTH_CARE_MINISTRIES_LOGO from '../../../../assets/images/alliance-of-health-care-sharing-ministries.png?url';
import { useTranslation } from '../../../../i18n/resources';
import styles from './FooterInfoBlock.module.css';

export type FooterInfoBlock = {
  className?: string;
};

export const FooterInfoBlock: FunctionComponent<FooterInfoBlock> = ({
  className,
}) => {
  const { renderTrans } = useTranslation();

  return (
    <div className={cx(styles.root, className)}>
      <div className={styles.logo}>
        <img
          alt="Alliance of Health Care Sharing Ministries"
          src={ALLIANCE_OF_HEALTH_CARE_MINISTRIES_LOGO}
          width={175}
        />
      </div>

      <div className={styles.caption}>
        {renderTrans('footer', 'disclaimer_body', {
          components: {
            stateDisclosureLink: (
              <a
                className={styles.link}
                href="https://mychristiancare.org/our-ministry/disclosures/"
              />
            ),
          },
        })}
      </div>
    </div>
  );
};
